import { STOCK_DOCUMENTS } from "../../../utils/inventory"
import { ACTION_TYPES, Actions } from "../actions"
import { stateHandler } from "./handler"
import { InitialState } from "./types"

const INITIAL_STATE: InitialState = {
    id: "",
    title: "",
    internalNotes: [],
    documentType: STOCK_DOCUMENTS,
    isLoaded: false,
    // @ts-ignore
    contact: {}
}

export const reducer = (state = INITIAL_STATE, action: Actions) => {
    const handler = stateHandler()

    switch (action.type) {
    case ACTION_TYPES.FETCH_SUCCESS:
        return handler.fetchSuccess(action.payload)
    default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/state/project/reducers/reducer.ts